import { render, staticRenderFns } from "./dishAnalysis.vue?vue&type=template&id=39deb533&scoped=true"
import script from "./dishAnalysis.vue?vue&type=script&lang=js"
export * from "./dishAnalysis.vue?vue&type=script&lang=js"
import style0 from "./dishAnalysis.vue?vue&type=style&index=0&id=39deb533&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39deb533",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39deb533')) {
      api.createRecord('39deb533', component.options)
    } else {
      api.reload('39deb533', component.options)
    }
    module.hot.accept("./dishAnalysis.vue?vue&type=template&id=39deb533&scoped=true", function () {
      api.rerender('39deb533', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/evaluateManifest/dishAnalysis.vue"
export default component.exports